import { getProductName } from '__common/constants/products';

export function createSearchLink(projectId: string, productId: number) {
  const productName = getProductName(productId);
  return `/project/design/${productName}/${projectId}`;
}
